export default {"src":"/_next/static/media/octicon_law-16.ac590639.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};